









import Vue, { PropType } from 'vue';
import * as api from '@/api';

export default Vue.extend({
    props: {
        tags: {
            type: Array as PropType<api.FilterBrand[]>,
            required: true,
        },
        bgcolor: {
            type: String,
            required: true,
        },
    },
    methods: {
        handleClick(tag: api.FilterBrand) {
            const idx = this.tags.findIndex((v) => v.id === tag.id);
            if (idx !== -1) {
                this.tags.splice(idx, 1);
            }
        },
    },
});
